import dayjs from 'dayjs';

/** The receipt belongs to the first successful card charge, even when resumed later. */
export const getReceiptDate = (checkout?: {
  createdAt?: string;
  cloverPayments?: { createdTime?: string | number | null }[];
}) => {
  const dates = (checkout?.cloverPayments || [])
    .map(payment => payment.createdTime)
    .filter(value => value != null && value !== '' && dayjs(value).isValid())
    .map(value => dayjs(value).valueOf());
  return dates.length ? Math.min(...dates) : checkout?.createdAt;
};
